import { FC, useCallback, useMemo, useState } from 'react';
import { contextFactory } from 'utils/general';

interface JobsContext {
  inProgressJobIds: string[];
  addInProgressJob: (jobId: string) => void;
  removeInProgressJob: (jobId: string) => void;
}

const [useJobsContext, JobsContextProvider] = contextFactory<JobsContext>();

export const JobsProvider: FC = ({ children }) => {
  const [inProgressJobIds, setInProgressJobIds] = useState<string[]>([]);

  const addInProgressJob = useCallback((jobId: string) => {
    setInProgressJobIds((prev) =>
      prev.includes(jobId) ? prev : [...prev, jobId],
    );
  }, []);

  const removeInProgressJob = useCallback((jobId: string) => {
    setInProgressJobIds((prev) => prev.filter((id) => id !== jobId));
  }, []);

  const value = useMemo(
    () => ({
      inProgressJobIds,
      addInProgressJob,
      removeInProgressJob,
    }),
    [addInProgressJob, inProgressJobIds, removeInProgressJob],
  );

  return <JobsContextProvider value={value}>{children}</JobsContextProvider>;
};

export { useJobsContext };
